<template>
<div>
     <template v-for="(element, i) in elements">
          <transition name="app-flat" :key="i">
               <vue-draggable-resizable @dragging="(left, top) => dragging(element.id, left, top)"  :resizable="element.id == 7 ? false : true"
                                                       @dragstop="(left, top) => dragstop(element.id, left, top)" @resizing="Resizing" 
                                                       class-name-dragging="my-dragging-class" :active.sync="element.active" :min-width="1018" 
                                                       @activated="onActivated(element.id)" @deactivated="onDeactivated(element.id)"
                                                        class-name="drag" :drag-handle="'.drag-handle'" :x="localLang == 'fr' ? element.x : element.x * -1" :y="element.y" 
                                                        :w="element.w" :style="'position: absolute;z-index: ' + element.zIndex + ' !important'" :h="element.h" 
                                                        @click.stop="drawer = !drawer" class-name-handle="handles">
 
                    <SystemBar class="text-center" :id="element.id" @minus='closes(element.id,false)' :idList="element.id" 
                    :path='element.path' :title="$t(element.text)" @close="closes(elements.id,true)" 
                    @returnDown="element.id != 7 ? returnDown(element.id) : null" :WithSearch="element.items.length !== 0" />

                   <v-app id="appinspire" class="onverFlow" > 
                          <template v-if="element.items.length !== 0">
                            <Drawer :items="element.items" :id="element.id" :path="element.path" @changeComponent="changComp($event,element.id)"/>
                        </template>
                         <v-content   class="fill-height  pt-1 onverFlow" dark>
                              <transition name="list">
                                   <component  :allData="element.items[id]" :idApp="element.id" :widthP="element.w" :heightP="element.h" 
                                                       :is="element.currentComponent"></component>
                              </transition>
                         </v-content>
                    </v-app>
               </vue-draggable-resizable>
          </transition>
     </template>
</div>
</template>

<script>
import SystemBar from './components/systemBar'
import Drawer from './components/drawer'
export default {
     name: 'MainApp',
     components: {
          SystemBar,
          Drawer
     },
     data: () => ({
          elements: [],
          id: 1,
          drawer: true,
          switch: false,
          mini: true,
          sync: false,
          draggingId: null,
          prevOffsetX: 0,
          prevOffsetY: 0,
     }),
     methods: {
          closes(e, i) {
               if (i) {
                    Fire.$emit('close', e)
               }
               this.elements.splice(this.elements.indexOf(e), 1)
          },
          returnDown(b) {
               var i = this.getIndexOf(b);
               this.elements[i].switch = false; 
                    if (this.elements[i].w != this.elements[i].window.w && this.elements[i].h != this.elements[i].window.h ||
                        this.elements[i].x != -10  && this.elements[i].y != -4) {
                    this.elements[i].switch = true;
               } 
               if (this.elements[i].switch) {
                    this.elements[i].oldPosition.w = this.elements[i].w;
                    this.elements[i].oldPosition.h = this.elements[i].h;
                    this.elements[i].oldPosition.x = this.elements[i].x;
                    this.elements[i].oldPosition.y = this.elements[i].y;
                    this.elements[i].w = this.elements[i].window.w
                    this.elements[i].h = this.elements[i].window.h - 108
                    this.elements[i].x =   -10  
                    this.elements[i].y = -20
                    this.elements[i].switch = false;
               } else {
                    this.elements[i].w = this.elements[i].oldPosition.w;
                    this.elements[i].h = this.elements[i].oldPosition.h;
                    this.elements[i].x = this.elements[i].oldPosition.x;
                    this.elements[i].y = this.elements[i].oldPosition.y;
               }
          },
          dragging(id, left, top) {
               this.draggingId = id;
               if (!this.sync) return;
               const offsetX = left - this.draggingElement.x;
               const offsetY = top - this.draggingElement.y;
               const deltaX = this.deltaX(offsetX);
               const deltaY = this.deltaY(offsetY);
               this.elements.map(el => {
                    if (el.id !== id) {
                         el.x += deltaX;
                         el.y += deltaY;
                    }
                    return el;
               });
          },
          dragstop(id, left, top) {
               var i = this.getIndexOf(id);
               if (top < -22) {
                    this.elements[i].y = -22
               } else {
                    this.elements[i].y = top
               }
          },
          deltaX(offsetX) {
               const ret = offsetX - this.prevOffsetX;
               this.prevOffsetX = offsetX;
               return ret;
          },
          deltaY(offsetY) {
               const ret = offsetY - this.prevOffsetY;
               this.prevOffsetY = offsetY;
               return ret;
          },

          Resizing(x, y, w, h) {
               Fire.$emit('changHeight', h);
          },
          onActivated(e) {
               this.elements.filter((t) => {
                    if (t.id == e) {
                         return t.zIndex = 10
                    }
               })
          },
          onDeactivated(e) {
               this.elements.filter((t) => {
                    if (t.id == e) {
                         return t.zIndex = t.id
                    }
               })
               // this.active = false
          },
          getIndexOf(item) {

               var i = -1
               this.elements.find((e, index) => {
                    if (e.id == item) {
                         i = index
                    }
               })
               return i
          },
          handleResize() {
               this.elements.filter((e) => {
                    e.window.w = window.innerWidth;
                    e.window.h = window.innerHeight;
               })
          },
     },
     computed: {
          
     },
     created() { 
          this.$store.dispatch('getMessage')
          this.$store.dispatch('getDemandes')
          this.$store.dispatch('getQuastion')
          Fire.$on('openApp', (e) => {
               if (this.getIndexOf(e.id) === -1) {
                    this.elements.push(e)
               }

               this.elements.filter((r) => {
                    if (r.id == e.id) {
                         return r.active = true
                    } else {
                         return r.active = false
                    }
               })
               window.addEventListener('resize', this.handleResize)
               this.handleResize();
          })
     },
     destroyed() {
          window.removeEventListener('resize', this.handleResize)
     },
}
</script>

<style scoped>
.onverFlow { 
     overflow: auto
}
</style>
